import { render, staticRenderFns } from "./LeaseRecord.vue?vue&type=template&id=0bcc3963&scoped=true&"
import script from "./LeaseRecord.vue?vue&type=script&lang=js&"
export * from "./LeaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./LeaseRecord.vue?vue&type=style&index=0&id=0bcc3963&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc3963",
  null
  
)

export default component.exports